import template from './requestFormSickLeaveReports.html';
import controller from './requestFormSickLeaveReports.controller';
import './requestFormSickLeaveReports.scss';

let requestFormSickLeaveReportsComponent = {
  restrict: 'E',
  bindings: {
    form: '<',
    startDate: '<',
    sickLeaveReports: '<',
    isMobileApp: '<',
  },
  template,
  controller
};

export default requestFormSickLeaveReportsComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/requestForm/requestFormSickLeaveReports/requestFormSickLeaveReports.component.js